var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page',{staticClass:"flex column page-layout game-assets"},[_c('DropboxEmbed',{attrs:{"url":_vm.link}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }